module.exports = __webpack_public_path__ + "static/media/pencil.eac4f3d9.svg";